import { render, staticRenderFns } from "./AcoesMinhasConsultas.vue?vue&type=template&id=07384275"
import script from "./AcoesMinhasConsultas.vue?vue&type=script&lang=js"
export * from "./AcoesMinhasConsultas.vue?vue&type=script&lang=js"
import style0 from "./AcoesMinhasConsultas.vue?vue&type=style&index=0&id=07384275&prod&lange=less&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports